"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionDropdown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const downshift_1 = require("downshift");
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const ActionDropdownListItem_1 = require("./ActionDropdownListItem");
function ActionDropdown({ children, items, onButtonClick, className = '' }) {
    const { isOpen, getToggleButtonProps, getMenuProps, highlightedIndex, getItemProps } = (0, downshift_1.useSelect)({
        items,
        itemToString: (item) => (item ? item.label : '')
    });
    const TriggerButton = (0, react_1.cloneElement)(children, Object.assign({}, getToggleButtonProps({
        onClick: onButtonClick ? onButtonClick : undefined
    })));
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsxs)(react_popper_1.Manager, { children: [(0, jsx_runtime_1.jsx)(react_popper_1.Reference, { children: ({ ref }) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: "inline-block", ref: ref }, { children: TriggerButton }))) }), (0, jsx_runtime_1.jsx)("div", Object.assign({}, getMenuProps(), { children: isOpen && ((0, jsx_runtime_1.jsx)(react_popper_1.Popper, Object.assign({ placement: "bottom-end", modifiers: [
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 8]
                                }
                            }
                        ] }, { children: ({ ref, style, placement }) => ((0, jsx_runtime_1.jsx)("ul", Object.assign({ ref: ref, style: style, "data-placement": placement, className: (0, classnames_1.default)('absolute', 'border', 'border-silver-30', 'shadow-md', 'bg-white', 'rounded-md', 'py-2', 'w-fit') }, { children: items.map((item, index) => ((0, jsx_runtime_1.jsx)(ActionDropdownListItem_1.ActionDropdownListItem, { highlightedIndex: highlightedIndex, index: index, item: item, getItemProps: getItemProps }, `${item.label}-${index}`))) }))) }))) }))] }) })));
}
exports.ActionDropdown = ActionDropdown;
//# sourceMappingURL=ActionDropdown.js.map